import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function CategoryQuick() {
  return (
    <section className="w-full">
      <div className="flex items-end justify-between mb-5">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">分类快捷入口</h2>
          <p className="text-sm text-foreground-500 mt-1">按兴趣挑一个频道，发现更多精彩内容</p>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className={`group relative flex flex-col items-center justify-center gap-3 py-5 rounded-lg border border-background-200 bg-gradient-to-b ${cat.gradient} hover:border-primary-300 hover:-translate-y-1 transition-all duration-300 cursor-pointer`}
          >
            <span className="w-12 h-12 rounded-full bg-background-50 flex items-center justify-center text-primary-500 text-2xl group-hover:scale-110 transition-transform">
              <i className={cat.icon}></i>
            </span>
            <span className="text-sm font-medium text-foreground-800">{cat.name}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}